import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';
import { UiDialog } from 'ui-components';
import { marginLeft, paddingLeft } from 'utils';

export const StyledUiDialog = styled(UiDialog)(
  () => css`
    .MuiPaper-root {
      max-width: 800px !important;
    }
  `
);

export const StyledMain = styled('div')(
  ({ theme }) => css`
    display: flex;

    .selected-filter-wrapper {
      padding: 24px;
      width: 100%;

      h1 {
        color: ${theme.palette.naturals.black};
        font-size: ${theme.typography.subtitle.fontSize};
        font-weight: ${theme.typography.subtitle.fontWeight};
        line-height: ${theme.typography.subtitle.lineHeight};
      }

      .filter {
        display: flex;
        flex-direction: column;
        max-height: 60vh;
        min-height: 50vh;
        overflow-y: auto;
        overflow-x: hidden;
        margin-bottom: 0px !important;
        ${paddingLeft('8px')}

        &::-webkit-scrollbar {
          width: 8px;
        }

        &::-webkit-scrollbar-track {
          background: transparent;
        }

        &::-webkit-scrollbar-thumb {
          background: transparent;
        }

        &:hover {
          &::-webkit-scrollbar-thumb {
            background: ${theme.palette.gray.lighter};
          }

          &::-webkit-scrollbar-track {
            background: transparent;
          }
        }
      }

      .MuiAlert-icon {
        ${marginLeft('8px')}
      }

      .MuiFormGroup-root {
        display: flex !important;
      }
    }
  `
);

export const StyledActions = styled('div')(
  ({ theme }) => css`
    border-top: 1px solid ${theme.palette.gray.lighter};
    display: flex;
    padding: 16px 32px;
    align-items: center;
    justify-content: space-between;

    .end-actions {
      display: flex;
      gap: 12px;
    }
  `
);
